<ion-header class="m-issue-selection-header">
  <ion-row class="m-issue-selection-header__content">
    <div class="back-icon" (click)="handleBack()">
      <ion-img [src]="backArrow"></ion-img>
    </div>
    <div>{{ 'issue_selection.heading' | translate }}</div>
  </ion-row>
</ion-header>
<ion-content class="m-issue-selection-content">
  <div class="m-issue-selection-content__container">
    <ion-row style="height: 100%">
      <ion-col size="4" class="operation-listing operation-listing-col">
        <div
          *ngFor="let item of operationAndSelectedIssueList; let i = index"
          class="operation-listing__item"
          [ngClass]="{ 'operation-listing__item--active': activeIndex === i }"
          (click)="updateActiveIndex(i)"
        >
          {{ item.operation.name }}
        </div>
      </ion-col>
      <ion-col size="8" class="issue-listing-col">
        <div class="issue-listing">
          <ion-row class="issue-listing__heading ion-justify-content-between">
            <ion-col size="5" class="ion-no-padding">{{ 'issue_selection.issue' | translate }}</ion-col>
            <ion-col size="5" class="ion-no-padding filter" (click)="onViewAllClick()">{{
              'input_app_common.viewAll' | translate
            }}</ion-col>
          </ion-row>
          <div class="operation-name">
            {{ operationAndSelectedIssueList[activeIndex].operation.name | titlecase }}
          </div>
          <div class="issue-listing__content">
            <monorepo-multi-select
              [lists]="issueList"
              [preSelectedList]="operationAndSelectedIssueList[activeIndex].selectedIssue"
              (selectedList)="handleIssueSelection($event)"
              [showCategoryId]="true"
            ></monorepo-multi-select>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
</ion-content>
<ion-footer>
  <ion-row class="m-issue-selection-footer ion-justify-content-between">
    <ion-col sizeLg="2" sizeMd="4" class="ion-no-padding">
      <ui-custom-button
        [buttonHeight]="'56px'"
        [buttonType]="'SECONDARY'"
        [btnTxt]="'input_app_common.clearAll' | translate"
        (clickEvent)="handleClearAll()"
      ></ui-custom-button
    ></ion-col>
    <ion-col sizeLg="4" sizeMd="6" class="ion-no-padding" style="text-align: end">
      <ui-custom-button
        [buttonHeight]="'56px'"
        [buttonType]="'SECONDARY'"
        [btnTxt]="'input_app_common.cancel' | translate"
        style="margin-right: 16px"
        (clickEvent)="handleCancel()"
      ></ui-custom-button>
      <ui-custom-button
        [buttonHeight]="'56px'"
        [btnTxt]="'input_app_common.next' | translate"
        (clickEvent)="handleNext()"
        [isDisabled]="!issueList.length"
      ></ui-custom-button>
    </ion-col>
  </ion-row>
</ion-footer>
